export default __webpack_public_path__ + "static/media/Lucis.e58410bc.jpg";